export enum MapZonesOverlay {
  SourceId = 'map-zones-overlay',
  FillLayerId = 'map-zones-fills',
  BorderLayerId = 'map-zones-borders',
  LabelLayerId = 'map-zones-texts',
}
